// extracted by mini-css-extract-plugin
export var buttonContent = "_32-0";
export var centered = "_32-1";
export var centeredFlex = "_32-2";
export var errorText = "_32-3";
export var icon = "_32-4";
export var iconButtonContent = "_32-5";
export var monospace = "_32-6";
export var padded = "_32-7";